var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"start"}},_vm._l((_vm.businesses),function(business,i){return _c('v-col',{key:'grid-' + business.id + '-' + i,staticClass:"businesses-grid__col",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('BusinessGridItem',{staticClass:"my-2",attrs:{"business":business}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }